import idx from 'idx';
import * as React from 'react';
import { Query } from 'react-apollo';
import { InjectedRouter } from 'react-router';

import { withRouter } from 'app/context/Router';
import ErrorReporter from 'app/components/ErrorReporter';
import LayerTrigger from 'components/LayerTrigger';
import Link from 'components/Link';
import ModalTrigger from 'components/ModalTrigger';
import QUERY from './queries/NavigationListCreateGroupAction.gql';
// @ts-ignore
import Timestamp from 'components/Timestamp';
import Tooltip from 'components/Tooltip';
// @ts-ignore
import Group from 'entities/Group';
// @ts-ignore
import GroupCreateModal from 'groups/components/GroupCreateModal';
// @ts-ignore
import getRedirectLocationAfterGroupCreation from 'utils/getRedirectLocationAfterGroupCreation';
import { NavigationListCreateGroupAction as NavigationListCreateGroupActionQuery } from './queries/__generated__/NavigationListCreateGroupAction';

type Props = {
  router: InjectedRouter;
};

function NavigationListCreateGroupAction(props: Props) {
  const handleGroupCreated = (group: Group) => {
    props.router.push(getRedirectLocationAfterGroupCreation(group));
  };

  return (
    <Query<NavigationListCreateGroupActionQuery> query={QUERY} fetchPolicy="network-only">
      {({ loading, error, data }) => {
        if (loading) {
          return (
            <Link disabled color="pitch">
              Create new group
            </Link>
          );
        }

        if (error || !data || !data.me) {
          return <ErrorReporter error="NavigationListCreateGroupAction - could not load user" />;
        }

        const canCreateGroup = idx(data.me, _ => _.permissions.can_create_group);
        const mutedUntil = idx(data.me, _ => _.muted_until);

        const link = (
          <Link
            disabled={!canCreateGroup}
            className="NavigationList-section-header"
            data-test="create-new-group-link"
            data-test-selector="create_class_nav_link"
            eventElementName="NavigationList-add-class"
            color="pitch"
            noHover>
            Create new group
          </Link>
        );

        if (canCreateGroup) {
          return (
            <ModalTrigger
              modal={<GroupCreateModal onCreate={handleGroupCreated} onRequestHide={() => {}} />}>
              {link}
            </ModalTrigger>
          );
        }

        if (mutedUntil) {
          return (
            <LayerTrigger
              layer={
                <Tooltip>
                  Your messaging privileges have been temporarily suspended until{' '}
                  <Timestamp date={new Date(mutedUntil)} format="long" />.
                </Tooltip>
              }
              placement="bottom">
              {link}
            </LayerTrigger>
          );
        }

        return link;
      }}
    </Query>
  );
}

export { NavigationListCreateGroupAction };
export default withRouter(NavigationListCreateGroupAction);
